<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0">

        <v-layout row px-10 mb-4 justify-center>
            <v-flex md10 pa-10>

                <h1 class="text--teal">Your Orders</h1>
                
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search Your Displayed Orders"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table 
                        :headers="header_orders"
                        :items="address"
                        :page.sync="page"
                        :items-per-page="items_per_page"
                        :hide-default-footer="true"
                        :search="search"
                        class="elevation-1"
                        item-key="id"
                        no-data-text="No address data"
                        @page-count="length_pagination = $event"
                    >
                        <!--<template
                            v-slot:item.name="{ item }" >{{ getName(item) }}
                        </template>-->
                        <template v-slot:item.excludes="{ item }">
                            <v-checkbox v-model="item.exclude" class="pb-0 mb-0" v-on:change="changeExclude(item)"></v-checkbox>
                            <v-icon large color="red darken-2" @click="download()">mdi-download</v-icon>
                        </template>
                    </v-data-table>
                </v-card>

                <v-container>
                    <v-row>
                        <v-col cols="2" sm12 class="pt-8 px-4">
                            <v-select
                                :items="order_records"
                                label="Orders per page"
                                v-model="items_per_page"
                                @input="items_per_page = parseInt($event, 10)"
                            ></v-select>
                        </v-col>
                        <v-col cols="2" sm12>

                        </v-col>
                        <v-col cols="4" sm12>
                            <v-container class="float-right text-right">
                                <v-pagination 
                                        v-model="page"
                                        class="my-4 float-right"
                                        :length="length_pagination"
                                ></v-pagination>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-container>

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-flex>

            <v-snackbar v-model="orderDataFailure" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem accessing order information. Please try again.
                <v-btn dark text @click="orderDataFailure = false">
                    Close
                </v-btn>
            </v-snackbar>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        data() {
            return {
                data: [],
                loading: false,
                orderDataFailure: false,
                accountsApiRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                dataOrderApiRouteUrl: `${process.env.VUE_APP_DATAORDERAPIHOST}`,
                //catalogueRef: 'a27804e1-8771-4e96-bbde-9f209421c621',
                header_orders: [
                    {text: 'Order Id', value: 'order_id'},
                    {text: 'Order Ref', value: 'order_ref'},
                    {text: 'Status', value: 'status'},
                    {text: 'Created', value: 'created'},
                    {text: 'Cost (GBP)', value: 'cost'},
                    {text: 'Download Artwork', value: 'download'}
                ],
			}
        },
        components: {
        },
        mixins: [axios],
        computed: {
        },
        mounted() {
            //https://livetkgateway.azurewebsites.net/Search/customerSearch?source=PDFUpload&startDate=2020-03-01&endDate=2020-04-01&skip=0&top=20

            //const endpoint = 'https://partnerapi.ravensworth.uk/api/services/app/Catalogues/GetFilteredPrintCatalogueVariants?catalogueRef=a27804e1-8771-4e96-bbde-9f209421c621&orderSource=IMA&fCode=' + template.fCode + '&grouped=false';
            //const endpoint = this.accountsApiRouteUrl + '/api/services/app/Catalogues/GetFilteredPrintCatalogueVariants?catalogueRef=' + this.catalogueRef + '&orderSource=IMA&fCode=' + template.fCode + '&grouped=false';
            //const endpoint = this.accountsApiRouteUrl + '/Search/customerSearch?source=PDFUPLOAD&startDate=2020-03-01&endDate=2020-04-01&skip=0&top=20';
            //const endpoint = this.accountsApiRouteUrl + '/api/services/app/Catalogues/GetFilteredPrintCatalogueVariants?catalogueRef=' + this.catalogueRef + '&orderSource=PDFUPLOAD&grouped=false';
            const endpoint = this.dataOrderApiRouteUrl + '/api/v1/pdfupload/orders';

            console.log(endpoint)

            Axios.get(endpoint, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response);
                    
                    
                    
                    /*console.log(response.data.result[0]);
                    this.category = response.data.result[0].category1;
                    this.predefinedSelections.subCategory = response.data.result[0].category2;
                    this.printWorkflow[0].selected_value = response.data.result[0].finishedSize;
                    this.printWorkflow[1].selected_value = response.data.result[0].finishedOrientation;
                    this.printWorkflow[2].selected_value = response.data.result[0].pageCount;
                    this.printWorkflow[3].selected_value = response.data.result[0].foldType;
                    this.printWorkflow[4].selected_value = response.data.result[0].creasing;
                    this.printWorkflow[5].selected_value = response.data.result[0].stockType;
                    this.printWorkflow[6].selected_value = response.data.result[0].stockWeight;
                    this.printWorkflow[7].selected_value = response.data.result[0].lamination;
                    this.printWorkflow[8].selected_value = this.quantity;
                    this.product = this.getProduct(response.data.result[0]);
                    this.prefilAllSelections();*/
                })







        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            download() {
                console.log('download');

            },
            //previewData() {
            //    if (event.currentTarget.classList.contains('btn-disabled')) {
            //        return;
            //    }

            //    console.log('preview data');
            //    this.navigate('data-preview');
            //}
		}
    };
</script>